export const TYPE_CHAT_STREAM_START="chat/TYPE_CHAT_STREAM_START";
export const TYPE_CHAT_STREAM_UPDATE="chat/TYPE_CHAT_STREAM_UPDATE";
export const TYPE_CHAT_SUCCESS="chat/TYPE_CHAT_SUCCESS";
export const TYPE_CHAT_FAILURE="chat/TYPE_CHAT_FAILURE";
export const TYPE_CHAT_CLEAR = "chat/TYPE_CHAT_CLEAR";
export const CHAT_HISTORY_MONTH_SUCCESS="chat/CHAT_HISTORY_MONTH_SUCCESS";
export const CHAT_HISTORY_MONTH_FAILURE = "chat/CHAT_HISTORY_MONTH_FAILURE";
export const TYPE_CHAT_STREAM_META="chat/TYPE_CHAT_STREAM_META";
export const TYPE_CHAT_RESET = "chat/TYPE_CHAT_RESET";
export const RAG_UPLOAD_SUCCESS = "chat/RAG_UPLOAD_SUCCESS";
export const RAG_UPLOAD_FAILURE = "chat/RAG_UPLOAD_FAILURE";
export const GET_SESSION_DATA_SUCCESS = "chat/GET_SESSION_DATA_SUCCESS";
export const GET_SESSION_DATA_FAILURE = "chat/GET_SESSION_DATA_FAILURE";
export const GET_ALL_SESSIONS_SUCCESS = "chat/GET_ALL_SESSIONS_SUCCESS";
export const GET_ALL_SESSIONS_FAILURE = "chat/GET_ALL_SESSIONS_FAILURE";

